import { usePermissions } from '../../../../hooks/usePermissions';
import { useGetSpaceAISettings } from '../../api/useGetSpaceAISettings';

type Props = {
  spaceId?: string;
};

const SETTINGS_HINT = 'Réglage : Paramètres de l’espace › Intelligence artificielle.';

export function useAiStatusTag(props: Props) {
  const { isAdmin } = usePermissions();
  const { data: isAiEnabled, isLoading } = useGetSpaceAISettings({ spaceId: props.spaceId });

  const explanation = isAiEnabled
    ? 'Les e-mails et leurs pièces jointes sont analysés par l’IA (résumé, devis, rendez-vous, prestataires).'
    : 'Les e-mails sont triés par règles simples, sans IA.';

  return {
    isVisible: !isLoading && isAiEnabled !== undefined,
    isAiEnabled: Boolean(isAiEnabled),
    label: isAiEnabled ? 'Analyse IA activée' : 'Analyse IA désactivée',
    // Only admins can change it: others just learn what it means.
    tooltip: isAdmin ? `${explanation} ${SETTINGS_HINT}` : explanation,
  };
}
